export default __webpack_public_path__ + "static/media/fund.92d1a0b2.png";